var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    viewBox: "0 0 784.98 784.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter3690",
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    id: "feMorphology3692",
    result: "result0",
    radius: 4,
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur3694",
    result: "result91",
    stdDeviation: 8,
    in: "result0"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite3696",
    operator: "in",
    in2: "result91",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3706",
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    id: "feMorphology3708",
    result: "result0",
    radius: 4,
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur3710",
    result: "result91",
    stdDeviation: 8,
    in: "result0"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite3712",
    operator: "in",
    in2: "result91",
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer4",
    transform: "translate(-142.1 17.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2891",
    d: "m314.52 144.6c46.3 31.624 106.74 88.193 61.216-42.218 54.037 92.848 83.809 109.59 75.993 8.4436 26.055 72.316 50.641 55.035 73.882-44.329 13.578 194.3 38.841 128.61 63.327 80.214 3.8603 14.044-5.2992 62.14 14.776 33.774 61.877 45.502 115.83-30.18 156.21-75.993-63.211 112.87 34.494 74.57 103.96 62.799-91.412 71.71 25.486 34.85 48.023 23.748-29.055 25.115-65.927 53.807-14.776 42.218-57.105 53.476-64.299 97.745 23.22 124.54-30.868 15.066-40.952 46.286 4.2218 46.44-28.394 2.2971-38.043 17.274 0 23.22-129.63 24.689-50.171 62.472-12.665 92.88-188.38-52.17-83.211 58.621-14.776 109.77-121.18-72.162-256.69-129.33-143.54 2.1109-28.809-15.725-68.69-48.751-54.884 2.1109-44.946-59.837-55.449-48.764-52.773-10.555-43.802-48.395-67.3-26.647-80.214 31.664-21.551-12.746-26.051-76.647-86.547 27.442 7.8133-47.605-13.536-51.467-50.662-31.664 0.45541-58.504-46.697 9.3318-61.216 23.22 6.9535-77.689-28.015-47.58-59.105-27.442 25.699-86.245-73.282-36.475-132.99-29.553 57.339-35.508 110.38-70.333 46.44-86.547 78.371-55.288-22.759-47.959-52.773-65.438 29.086-12.932 88.792-16.36 42.218-52.773 52.197-38.357-35.826-55.468-66.494-81.27 58.542-5.3782 131.45-6.458 65.438-44.329 27.5 1.4363 49.35 4.7973 15.832-24.275 46.994 22.432 21.306-40.457 6.3327-90.769 60.403 56.911 141.87 91.475 82.325-27.442z",
    stroke: "#ff2626",
    strokeWidth: 5,
    fill: "#f56d3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2916",
    filter: "url(#filter3690)",
    d: "m314.52 144.6c46.3 31.624 106.74 88.193 61.216-42.218 54.037 92.848 83.809 109.59 75.993 8.4436 26.055 72.316 50.641 55.035 73.882-44.329 13.578 194.3 38.841 128.61 63.327 80.214 3.8603 14.044-5.2992 62.14 14.776 33.774 61.877 45.502 115.83-30.18 156.21-75.993-63.211 112.87 34.494 74.57 103.96 62.799-91.412 71.71 25.486 34.85 48.023 23.748-29.055 25.115-65.927 53.807-14.776 42.218-57.105 53.476-64.299 97.745 23.22 124.54-30.868 15.066-40.952 46.286 4.2218 46.44-28.394 2.2971-38.043 17.274 0 23.22-129.63 24.689-50.171 62.472-12.665 92.88-188.38-52.17-83.211 58.621-14.776 109.77-121.18-72.162-256.69-129.33-143.54 2.1109-28.809-15.725-68.69-48.751-54.884 2.1109-44.946-59.837-55.449-48.764-52.773-10.555-43.802-48.395-67.3-26.647-80.214 31.664-21.551-12.746-26.051-76.647-86.547 27.442 7.8133-47.605-13.536-51.467-50.662-31.664 0.45541-58.504-46.697 9.3318-61.216 23.22 6.9535-77.689-28.015-47.58-59.105-27.442 25.699-86.245-73.282-36.475-132.99-29.553 57.339-35.508 110.38-70.333 46.44-86.547 78.371-55.288-22.759-47.959-52.773-65.438 29.086-12.932 88.792-16.36 42.218-52.773 52.197-38.357-35.826-55.468-66.494-81.27 58.542-5.3782 131.45-6.458 65.438-44.329 27.5 1.4363 49.35 4.7973 15.832-24.275 46.994 22.432 21.306-40.457 6.3327-90.769 60.403 56.911 141.87 91.475 82.325-27.442z",
    fill: "#fffe48",
    transform: "matrix(.83642 0 0 .83501 88.941 61.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3704",
    d: "m406.18 240.43c67.913 125.64 94.992 82.428 80.059-19.707 20.813 98.136 45.226 188.42 43.109-25.865 7.3423 175.75 77.261 151.07 136.72 22.17-83.998 108.34-8.8505 106.15 88.681 50.499-84.065 46.891-114.83 96.254 4.9267 97.303-168.65 7.2685-40.471 34.873 2.4634 40.645-25.441 39.236-188.72-33.563-131.79 120.7-51.996-155.29-73.037-80.546-77.596 12.317-14.217-88.06-26.056-125.59-80.059-2.4634 6.3924-158.95-27.322-77.334-70.206-2.4634 37.615-103.92-84.084-92.285-84.084-92.285 24.707-17.237 56.497-85.904-11.371-91.851 98.194 44.526 101.97 2.0646 51.115-92.992 62.43 95.683 118.64 135.8 48.036-16.012z",
    transform: "matrix(1.0689 0 0 .87549 2.7353 39.188)",
    filter: "url(#filter3706)",
    stroke: "#ff2626",
    strokeWidth: 1.0337,
    fill: "#faffac"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHit);
export default __webpack_public_path__ + "static/media/Hit.cfa8e69baa60fc90726e4fb5cff0d9e7.svg";
export { ForwardRef as ReactComponent };